module.exports = __webpack_public_path__ + "media/images/checkout-35da0a0f2b0b74afa431880ffd018c94.svg";